import * as React from 'react';
// tslint:disable-next-line: match-default-export-name
import Modal from 'react-modal';
import { CloseIcon } from '../../components/close_icon';
import { CheckAnounceRelevancePopupContent } from './components/content';
import { Button, ButtonTheme } from '@cian/button-component';
import { Preloader } from '@cian/preloader-component';

import { ANNOUNCEMENT_RELEVANCE_POPUP_WAS_SHOWN_COOKIE_KEY } from '../../../shared/constants';
import {
  trackingConfirmActualOfferPopup,
  trackingConfirmNotActualOfferPopup,
  trackingShowOfferPopup,
} from './tracking';
import { confirmActualAnnouncement, confirmNotActualAnnouncement } from './confirmation';
import { ENotificationType as ENotificationTypeConfirm } from '../../../shared/repositories/moderation-announcements-relevance/v3/announcements-relevance-confirm';
import { ENotificationType as ENotificationTypeConfirmNotActual } from '../../../shared/repositories/moderation-announcements-relevance/v3/announcements-relevance-confirm-not-actual';
import { setCookie } from '../../utils/cookie';
import { IPopupLinkData } from '../../../shared/types/moderation';

const styles = require('./style.css');

export enum ESingleAnnouncementMode {
  /** Начальное состояние */
  Initial,
  /** После клика на "неактуально" */
  NotActualConfirmed,
  /** После клика на "актуально" */
  ActualConfirmed,
}

interface IProps {
  /** Данные для попапа */
  popupData: IPopupLinkData | null;
}

interface IState {
  /** Видимость попапа */
  isOpen: boolean;
  /** Если API-запрос в процессе */
  fetching: boolean;
  /** Режим отображения контента (если объявление одно) */
  singleAnnouncementMode: ESingleAnnouncementMode;
  /** Если объявлений больше одного */
  hasMultiple: boolean;
}

export class CheckAnounceRelevancePopup extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    this.state = {
      isOpen: false,
      fetching: false,
      singleAnnouncementMode: ESingleAnnouncementMode.Initial,
      hasMultiple: false,
    };
  }

  private renderContent() {
    switch (this.state.singleAnnouncementMode) {
      case ESingleAnnouncementMode.Initial:
        return <CheckAnounceRelevancePopupContent link={this.props.popupData} />;
      case ESingleAnnouncementMode.NotActualConfirmed:
        return 'Ваше объявление будет отправлено в архив.';
      case ESingleAnnouncementMode.ActualConfirmed:
        return 'Ваше объявление остаётся опубликованным.';
    }
  }

  public render() {
    const { hasMultiple, fetching, singleAnnouncementMode, isOpen } = this.state;
    const isInitial = singleAnnouncementMode === ESingleAnnouncementMode.Initial;

    return (
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.handleClosePopup}
        style={{
          content: {
            backgroundColor: 'white',
            borderRadius: '4px',
            boxShadow: '0 5px 15px 0 rgba(186, 186, 186, 0.5)',
            overflow: 'visible',
            padding: '24px 32px 44px',
            position: 'relative',
            width: '510px',
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
            zIndex: 10001,
          },
          overlay: {
            alignItems: 'center',
            backgroundColor: 'rgba(24, 41, 48, .8)',
            display: 'flex',
            justifyContent: 'center',
            zIndex: 10000,
          },
        }}
      >
        <CloseIcon onClick={this.handleClosePopup} className={styles['close']} />

        <h3 className={styles['header']}>{isInitial ? 'Служба качества ЦИАН' : 'Спасибо за ответ!'}</h3>

        <div className={styles['wrapper']}>
          {fetching && (
            <div className={styles['preloader']}>
              <Preloader size={20} />
            </div>
          )}

          {hasMultiple ? (
            <>
              <span>Возможно, несколько ваших объявлений устарели.</span>
              <br />
              <span>Чтобы они остались опубликованными, подтвердите их актуальность</span>
            </>
          ) : (
            this.renderContent()
          )}

          {isInitial && (
            <div className={styles['buttons']}>
              {hasMultiple ? (
                <Button size="XS" onClick={this.handleConfirmMultipleClick}>
                  Подтвердить объявления
                </Button>
              ) : (
                <>
                  <Button size="XS" onClick={this.handleConfirmNotActualClick}>
                    Неактуально, снять с публикации
                  </Button>
                  <Button size="XS" theme={ButtonTheme.Ghost} onClick={this.handleConfirmActualClick}>
                    Объявление актуально
                  </Button>
                </>
              )}
            </div>
          )}
        </div>
      </Modal>
    );
  }

  public async componentDidMount() {
    const { popupData } = this.props;
    if (popupData && popupData.popupType === 'relevance') {
      this.setState({ isOpen: true, hasMultiple: popupData.itemsCount > 1 });
      this.setPopupWasShownCookie();
      trackingShowOfferPopup();
    }
  }

  private setPopupWasShownCookie = () => {
    setCookie(ANNOUNCEMENT_RELEVANCE_POPUP_WAS_SHOWN_COOKIE_KEY, '1', 1);
  };

  private handleClosePopup = () => this.setState({ isOpen: false });

  private handleConfirmActualClick = () => {
    const { popupData } = this.props;

    if (popupData && popupData.items && popupData.items[0].announcementRelevanceGuid) {
      this.setState({ fetching: true });

      confirmActualAnnouncement(popupData.items[0].announcementRelevanceGuid, ENotificationTypeConfirm.Popup)
        .then(() => {
          this.setState({ fetching: false, singleAnnouncementMode: ESingleAnnouncementMode.ActualConfirmed });
          trackingConfirmActualOfferPopup(popupData.items[0].realtyObjectId);
        })
        .catch(() => this.setState({ fetching: false }));
    }
  };

  private handleConfirmNotActualClick = () => {
    const { popupData } = this.props;

    if (popupData && popupData.items && popupData.items[0].announcementRelevanceGuid) {
      this.setState({ fetching: true });

      confirmNotActualAnnouncement(
        popupData.items[0].announcementRelevanceGuid,
        ENotificationTypeConfirmNotActual.Popup,
      )
        .then(() => {
          this.setState({ fetching: false, singleAnnouncementMode: ESingleAnnouncementMode.NotActualConfirmed });
          trackingConfirmNotActualOfferPopup(popupData.items[0].realtyObjectId);
        })
        .catch(() => this.setState({ fetching: false }));
    }
  };

  private handleConfirmMultipleClick = () => {
    window.open('https://my.cian.ru/notifications', '_blank');
    this.handleClosePopup();
  };
}
